
import React  from "react"
import styled from "styled-components"

const colorStyle = {
    default: {
        color: '#FFFFFF',
        borderWidth: '1px',
        borderColor: '#8495B1',
        background: '#4B6580',
        hoverBackground: '#456383',
        hoverBorder: '#1px solid #8495B1',
        disabledBackground: '#BBBBBB',
    },
    Primary: {
        color: '#FFFFFF',
        borderWidth: '0px',
        borderColor: 'none',
        background: '#234362',

        hoverBackground: '#2B3944',
        hoverBorder: 'none',

        disabledBackground: '#BDBDBD',
    },
    Secondary: {
        color: '#FFFFFF',
        borderWidth: '0px',
        borderColor: 'none',
        background: '#212121',

        hoverBackground: '#424242',
        hoverBorder: 'none',

        disabledBackground: '#E0E0E0',
    },
    Tertiary: {
        color: '#424242',
        borderWidth: '0px',
        borderColor: 'none',
        background: '#E0E0E0',

        hoverBackground: '#BDBDBD',
        hoverBorder: 'none',

        disabledBackground: '#EEEEEE',
        disabledColor: '#BDBDBD'
    },
    Quaternary: {
        color: '#FFFFFF',
        borderWidth: '0px',
        borderColor: 'none',
        background: '#003E00',        // 진한 초록
        hoverBackground: '#1B5E20',   // 더 어두운 초록
        hoverBorder: 'none',

        disabledBackground: '#EEEEEE',
        disabledColor: '#BDBDBD'
    },
    Outline: {
        color: '#212121',
        borderWidth: '1px',
        borderColor: '#E0E0E0',
        background: '#FFFFFF',

        hoverBackground: '#F5F5F5',
        hoverBorder: '#E0E0E0',

        disabledBackground: '#FFFFFF',
        disabledColor: '#BDBDBD'
    },
    Error: {
        color: '#FFFFFF',
        borderWidth: '1px',
        borderColor: '#FF0004',
        background: '#FF0004',

        hoverBorder: '#D4000D',
        hoverBackground: '#D4000D',
        disabledBackground: '#BBBBBB',
    },
    Switch: {
        color: '#FFFFFF',
        borderWidth: '0',
        borderColor: '#555555',
        background: '#555555',

        hoverBorder: '#555555',
        hoverBackground: '#555555',
        disabledBackground: '#F4F4F4',
        disabledColor: '#555555'
    }
};

const StdBtn = styled.button`

    display: flex;
    justify-content: center;
    align-items: center;
    
    column-gap: ${props => ({'sm': '8px', 'md': '8px', 'lg': '8px', 'xl': '8px'}[props.$size])};

    width: ${props => props.$addStyle.width};
    height: ${props => props.$addStyle.height};

    color: ${props => ! props.$addStyle.color ? colorStyle[props.$variant].color : props.$addStyle.color};
    
    //line-height: ${props => ({'sm': '20px', 'md': '22px', 'lg': '24px', 'xl': '26px'}[props.$size])};
    font-size: ${props => ({'sm': '13px', 'md': '15px', 'lg': '16px', 'xl': '18px'}[props.$size])};
    font-weight: ${props => ({'sm': '500', 'md': '500', 'lg': '600', 'xl': '700'}[props.$size])};

    font-style: normal;        
    font-family: 'Pretendard', sans-serif;
            
    //border-radius: ${props => ! props.$addStyle.borderRadius ? colorStyle[props.$variant].borderRadius : props.$addStyle.borderRadius};
    //border-radius:${props => ({'sm': '2px', 'md': '4px', 'lg': '7px', 'xl': '8px'}[props.$size])};
    border-radius: 2px;
    
    border-style: solid;
    
    border-width: ${props => props.$addStyle.borderWidth? props.$addStyle.borderWidth : colorStyle[props.$variant].borderWidth };
    border-color: ${props => colorStyle[props.$variant].borderColor};
            
    background: ${props => colorStyle[props.$variant].background};

    //transition: background-color 0.3s ease, border-color 0.3s ease; /* 애니메이션 천천히 */
    transition: all 0.3s ease;
    &:hover{
        border: ${props => "#1px solid "+colorStyle[props.$variant].hoverBorder}; 
        background: ${props => colorStyle[props.$variant].hoverBackground};
        box-shadow: ${props => colorStyle[props.$variant].boxShadow};
    }

    &:disabled, &.disabled {
        background-color: ${props => colorStyle[props.$variant].disabledBackground };
        color: ${props => colorStyle[props.$variant].disabledColor?colorStyle[props.$variant].disabledColor:colorStyle[props.$variant].color };
        //cursor: not-allowed;
    }
    
`;


const Button = props => {

    const {variant, size, addStyle={}, onClick, disabled} = props;

    return (
        <StdBtn
            $variant={variant}
            $size={size}
            $addStyle={addStyle}
            onClick={onClick}
            disabled={disabled}
        >
            {props.children}
        </StdBtn>
    )
}
export default Button


